/**
 * Quantity
 */
export default class Quantity {
    constructor(selector, options = {}) {
        this.container = selector;
        this.options = {
            decreaseSelectorClass: '.js-quantity-decrease',
            increaseSelectorClass: '.js-quantity-increase',
            onIncrease: null, // Callback for increase
            onDecrease: null, // Callback for decrease
            onChange: null,
            ...options,
        };
        this.setDecrease = this.setDecrease.bind(this);
        this.setIncrease = this.setIncrease.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    /**
     * Init function to attach events
     */
    init() {
        if (this.container.classList.contains('plugin-quantity-initialized')) return;
        this.input = this.container.querySelector('input');

        if (this.input) {
            this.container.quantity = this;
            this.min = this.input.getAttribute('min') ? parseFloat(this.input.getAttribute('min')) : 1;
            this.max = this.input.getAttribute('max') ? parseFloat(this.input.getAttribute('max')) : 10;

            const decrease = this.container.querySelector(this.options.decreaseSelectorClass);
            const increase = this.container.querySelector(this.options.increaseSelectorClass);

            decrease?.addEventListener('click', this.setDecrease);
            increase?.addEventListener('click', this.setIncrease);

            // Add input change listener
            this.input.addEventListener('change', this.handleInputChange);
        }

        this.container.classList.add('plugin-quantity-initialized');
    }


    setValue(value) {
        const newValue = Math.max(this.min, Math.min(this.max, parseFloat(value) || this.min));
        this.input.value = newValue;
        this.dispatchChangeEvent(newValue);
    }

    dispatchChangeEvent(value) {
        const event = new CustomEvent('quantity:change', {
            bubbles: true,
        });
        event.value = value;
        this.container.dispatchEvent(event);

        if (typeof this.options.onChange === 'function') {
            this.options.onChange(value);
        }
    }

    handleInputChange(e) {
        this.setValue(e.target.value);
    }


    /**
     * Increase quantity value
     */
    setIncrease() {
        let oldValue = parseFloat(this.input.value) || this.min;

        if (oldValue < this.max) {
            const newValue = oldValue + 1;
            this.input.value = newValue;
            this.dispatchChangeEvent(newValue);

            if (typeof this.options.onIncrease === 'function') {
                this.options.onIncrease(this.input.value, this.container);
            }
        }
    }

    /**
     * Decrease quantity value
     */
    setDecrease() {
        let oldValue = parseFloat(this.input.value) || this.min;

        if (oldValue > this.min) {
            const newValue = oldValue - 1;
            this.input.value = newValue;
            this.dispatchChangeEvent(newValue);

            if (typeof this.options.onDecrease === 'function') {
                this.options.onDecrease(this.input.value, this.container);
            }
        }
    }

    /**
     * Get current value
     * @returns {number} Current value of the quantity input
     */
    getValue() {
        return parseFloat(this.input.value) || this.min;
    }
}


document.addEventListener('DOMContentLoaded', () => {
    const selectors = Array.from(document.querySelectorAll('.js-quantity'));
    selectors.forEach((selector) => {
        const quantity = new Quantity(selector).init();
    });
});
